import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/active/required`;

export const ROUTE: RouteDefinition = `${baseRoute}/active/required`;

export const URL = (): RouteDefinition => `${baseRoute}/active/required`;
